
import React, { useState } from 'react';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import questionIcon from '../../assets/question-icon.png';

import './style.css'

interface IApproveLoanModalProps {
    isOpen: boolean;
    onConfirm: (startLoanDate: Date) => void;
    onCancel: () => void;
}

const ApproveLoanModal: React.FC<IApproveLoanModalProps> = ({ isOpen, onConfirm, onCancel }) => {

    const [startLoanDate, setStartLoanDate] = useState<Date | null>(null);
    const [dateError, setDateError] = useState('');

    if (!isOpen) {
        return null;
    }

    const handleConfirm = () => {
        if (!startLoanDate) {
            setDateError('Please select a start loan date.');
            return;
        }
        onConfirm(startLoanDate);
        setStartLoanDate(null);
        setDateError('');
    };

    const handleCancel = () => {
        setStartLoanDate(null);
        setDateError('');
        onCancel();
    };

    return (
        <div className="modal-overlay">
            <div className="modal-content">
                <div className='center-middle'>
                    <div className="icon-size-3">
                        <img className="responsive-image" src={questionIcon} alt="modal icon" />
                    </div>
                </div>
                <br />
                <div className='center-middle' style={{ color: '#347A54', fontSize: '28px', fontWeight: 'bold' }}>
                    Approve Application
                </div>
                <br />
                <div className="center-middle font-size-17px">
                    Are you sure you want to approve this loan application
                </div>
                <br />
                <div style={{ marginBottom: '16px', textAlign: 'center' }}>
                    <label style={{ display: 'block', marginBottom: '4px', fontWeight: 600, fontSize: '20px' }}>
                        Please Start Loan Date
                    </label>
                    <DatePicker
                        selected={startLoanDate}
                        onChange={(date: Date | null) => {
                            setStartLoanDate(date);
                            if (dateError) setDateError('');
                        }}
                        dateFormat="MM/dd/yyyy"
                        placeholderText="Select Date"
                        wrapperClassName="w-100"
                        customInput={
                            <input
                                style={{
                                    border: `1px solid ${dateError ? 'red' : '#f08080'}`,
                                    borderRadius: '8px',
                                    height: '50px',
                                    width: '400px',
                                    padding: '0 16px',
                                    outline: 'none',
                                    boxSizing: 'border-box',
                                    fontSize: '18px',
                                    textAlign: 'left',
                                }}
                            />
                        }
                    />
                    {dateError && (
                        <span style={{ display: 'block', color: 'red', fontSize: '12px', marginTop: '4px' }}>{dateError}</span>
                    )}
                </div>
                <hr style={{ border: '1px solid lightgray', margin: '0 0 16px 0' }} />
                <div className="center-middle">
                    <button type="button" className="btn-green-3 center-middle" onClick={handleConfirm}>Confirm</button>
                    &nbsp; &nbsp;
                    <button type="button" className="btn-white-green-3 center-middle" onClick={handleCancel}>Cancel</button>
                </div>
            </div>
        </div>
    );

}

export default ApproveLoanModal;
